import { Maybe } from 'shared/types'

const amountShort = new Intl.NumberFormat('en-US', {
  style: 'decimal',
  maximumFractionDigits: 0
})

const amountLong = new Intl.NumberFormat('en-US', {
  style: 'decimal',
  maximumFractionDigits: 2
})

export type AMOUNT_FORMAT = 'long' | 'short'

export function formatAmountLong(amount?: number | string | null) {
  return formatToXyro(amount, 'long')
}

export function formatToXyro(
  amount?: number | string | null,
  format: AMOUNT_FORMAT = 'short'
) {
  const value = amount ? Number(amount) : 0

  if (format === 'short') {
    return amountShort.format(value)
  }

  return amountLong.format(value)
}

const USD_PRECISION_THRESHOLDS = [
  [10000, 0],
  [1000, 1],
  [100, 2],
  [10, 3],
  [1, 4],
  [0.1, 5],
  [0.01, 6],
  [0.001, 7]
] as const

export const getUsdDisplayPrecision = (price: number) => {
  const abs = Math.abs(price)
  const match = USD_PRECISION_THRESHOLDS.find(([threshold]) => abs > threshold)

  return match?.[1] ?? 8
}

export const formatToUSD = (price?: Maybe<number>, precision = 2) => {
  if (price === 0) return '0.00'
  if (!price) return null

  return Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    maximumFractionDigits: precision
  }).format(price)
}

export const formatAssetUsd = (price?: Maybe<number>) => {
  if (price == null || Number.isNaN(price)) return null
  if (price === 0) return formatToUSD(0)

  const precision = getUsdDisplayPrecision(price)

  return Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: precision,
    maximumFractionDigits: precision
  }).format(Math.abs(price))
}

export const formatToTether = (price?: Maybe<number>, precision = 2) => {
  if (price === 0) return '0.00'
  if (!price) return null

  return Intl.NumberFormat('en-US', {
    style: 'decimal',
    maximumFractionDigits: precision
  }).format(price)
}
